import founderImage from '../assets/images/about-founder.png';

export const defaultData = {
    seo: {
        title: 'Über uns | Nexon Digital Studio',
        description:
            'Shopify Shop erstellen lassen in Deutschland: individuelles Design, saubere Theme-Entwicklung, Performance, SEO-Grundlagen und technische Betreuung.',
    },

    hero: {
        subtitle:
            'Nexon Digital Studio ist auf Shopify spezialisiert. Wir helfen kleinen Unternehmen, Selbstständigen und Online-Händlern in Deutschland dabei, professionelle Shopify-Shops aufzubauen, bestehende Stores zu verbessern und technische Anpassungen sauber umzusetzen.',
        title: ['Über Nexon', 'Digital Studio'],
        text: 'Shopify Entwicklung für kleine Unternehmen in Deutschland.',
        button: 'Anfrage senden',
    },
};

export const aboutFounderData = {
    title: 'Wer hinter Nexon Digital Studio steht',

    person: {
        name: 'Dmytro Kiriachek',
        role: 'Gründer von Nexon Digital Studio',
        text: 'Shopify-Entwicklung für kleine Unternehmen in Deutschland',
        image: founderImage,
        imageAlt: 'Dmytro Kiriachek von Nexon Digital Studio',
    },

    items: [
        {
            id: 1,
            number: '01',
            text: 'Nexon Digital Studio wurde von Dmytro Kiriachek gegründet, um Unternehmen beim Aufbau moderner, schneller und verkaufsorientierter Shopify-Shops zu unterstützen.',
        },
        {
            id: 2,
            number: '02',
            text: 'Viele kleine Unternehmen brauchen keine große Agentur mit komplizierten Prozessen, sondern einen direkten Ansprechpartner, klare Kommunikation und eine saubere technische Umsetzung.',
        },
        {
            id: 3,
            number: '03',
            text: 'Nexon Digital Studio setzt auf klares Shopify-Design, technische Entwicklung und einfache Lösungen für Unternehmen, die online wachsen möchten.',
        },
    ],
};

export const aboutShopifyReasonData = {
    title: 'Warum Shopify?',

    items: [
        {
            id: 1,
            title: 'Stabile Plattform für Online-Verkauf',
            text: 'Shopify ist eine stabile und bewährte E-Commerce-Plattform für Unternehmen, die Produkte online verkaufen möchten. Für viele kleine Unternehmen ist Shopify einfacher zu verwalten als individuell programmierte Shopsysteme.',
        },
        {
            id: 2,
            title: 'Einfach im Alltag zu verwalten',
            text: 'Produkte, Bestellungen, Lagerbestand und Inhalte können direkt im Shopify-Admin gepflegt werden. Das macht den Shop-Alltag übersichtlich und reduziert technische Abhängigkeiten.',
        },
        {
            id: 3,
            title: 'Flexibel für Wachstum',
            text: 'Ein Shopify-Shop kann Schritt für Schritt erweitert werden — mit neuen Produktbereichen, Apps, Zahlungsoptionen, Automatisierungen und technischen Verbesserungen.',
        },
    ],

    text: 'Nexon Digital Studio hilft kleinen Unternehmen in Deutschland dabei, Shopify richtig aufzubauen, bestehende Stores zu verbessern und eine klare technische Grundlage für den Online-Verkauf zu schaffen.',
};

export const aboutServicesData = {
    title: 'Was wir machen',
    subtitle:
        'Nexon Digital Studio bietet Shopify-Leistungen für kleine Unternehmen in Deutschland.',
    text: 'Wir machen keine beliebigen Websites für jeden Zweck. Unser Schwerpunkt ist Shopify.',

    groups: [
        {
            id: 1,
            items: ['Shopify Shop Erstellung', 'Shopify Einrichtung', 'Shopify Theme-Anpassung'],
        },
        {
            id: 2,
            items: [
                'Technische Shopify-Umsetzung',
                'Shopify Relaunch',
                'mobile Optimierung von Shopify-Stores',
            ],
        },
        {
            id: 3,
            items: [
                'Anpassung von Shopify Dawn',
                'Personalisierung der Checkout-nahen Seiten',
                'Startseiten für Shopify-Shops',
            ],
        },
        {
            id: 4,
            items: [
                'Grundlegende technische SEO-Struktur',
                'Unterstützung nach dem Launch',
                'Shopify Migration',
            ],
        },
    ],

    bottomText:
        'Nexon Digital Studio unterstützt kleine Unternehmen in Deutschland bei der Erstellung, Anpassung und Verbesserung von Shopify-Shops — von der Einrichtung und Theme-Anpassung bis zu Relaunch, Migration, mobiler Optimierung und technischer Umsetzung nach dem Launch.',
};

export const aboutAudienceData = {
    title: 'Für wen wir arbeiten',

    items: [
        {
            id: 1,
            title: 'Kleine Unternehmen',
            text: 'Wir arbeiten mit kleinen Unternehmen, Selbstständigen und lokalen Marken, die einen professionellen Shopify-Shop benötigen, um Produkte klar und zuverlässig online zu verkaufen.',
        },
        {
            id: 2,
            title: 'Online-Händler',
            text: 'Typische Kunden sind Online-Händler, die Produkte verkaufen und dafür eine klare, moderne und technisch saubere angepasste Shopify-Lösung brauchen.',
        },
        {
            id: 3,
            title: 'Bestehende Shopify-Stores',
            text: 'Wir unterstützen auch bestehende Shopify-Stores, die unübersichtlich, langsam, technisch unsauber oder nicht mehr passend aufgebaut sind.',
        },
    ],

    text: 'Nexon Digital Studio richtet sich an kleine Unternehmen in Deutschland, die Shopify gezielt für den Online-Verkauf nutzen möchten — von der Erstellung neuer Shops bis zur Verbesserung bestehender Shopify-Stores.',
};

export const aboutWorkflowData = {
    title: 'Wie die Zusammenarbeit abläuft',
    subtitle: 'Klare Schritte statt komplizierter Agenturprozesse.',

    notes: [
        {
            id: 1,
            text: 'Am Anfang prüfen wir, ob Shopify für Ihr Projekt sinnvoll ist, welche Produkte verkauft werden und welche technischen Anforderungen bestehen.',
        },
        {
            id: 2,
            text: 'Danach erhalten Sie eine klare Einschätzung zu Aufwand, Shop-Struktur, Umsetzung und den nächsten Schritten.',
        },
    ],

    steps: [
        {
            id: 1,
            number: '01',
            title: '<span>Analyse</span> des bestehenden oder geplanten Shopify-Shops',
        },
        {
            id: 2,
            number: '02',
            title: 'Planung der <span>Shop-Struktur</span>',
        },
        {
            id: 3,
            number: '03',
            title: 'Einrichtung oder Anpassung <span>des Shopify-Themes</span>',
        },
        {
            id: 4,
            number: '04',
            title: '<span>Umsetzung</span> von Startseite, Produktseiten und Collections',
        },
        {
            id: 5,
            number: '05',
            title: '<span>Mobile Prüfung</span> und technische Anpassungen',
        },
        {
            id: 6,
            number: '06',
            title: '<span>Launch, Tests</span> und Unterstützung nach dem Start',
        },
        {
            id: 7,
            number: '07',
            title: '<span>Launch</span> oder Übergabe',
        },
        {
            id: 8,
            number: '08',
            title: '<span>Unterstützung</span> nach dem Start',
        },
    ],
};
